import { useState, useEffect } from "react";
import api from "../api";

const useFetchAllSearches = () => {
  const [loading, setLoading] = useState(false);
  const [allSearches, setAllSearches] = useState(null);

  const payload = {};

  const fetchAllSearches = async ({ skipCache } = { skipCache: false }) => {
    setLoading(true);

    let config;
    if (skipCache) {
      config = {
        headers: {
          "cache-control": "no-cache"
        }
      };
    }

    // @TODO create a service with this api call.
    const { data } = await api.post("/allSearches", payload, config);

    setAllSearches(data);

    setLoading(false);
  };

  useEffect(() => {
    fetchAllSearches();
  }, []);

  return { loading, allSearches, fetchAllSearches };
};

export { useFetchAllSearches };
